import './App.css';
import TicTacToe from './Component/TicTacToe';

function App() {
  return (
    <div className="App">
      <TicTacToe></TicTacToe>
    </div>
  );
}

export default App;
